export function worldMusicMood({ district, boss = false, detection = 0, sneaking = false }) {
  if (boss) return 'boss';
  if (detection > 0.55) return 'battle';
  if (sneaking) return 'stealth';
  if (district === 'brackenwake' || district === 'ironpass') return 'village';
  if (['chapel', 'red-chapel', 'duskfall-crypt', 'hollow'].includes(district)) return 'haunted';
  if (['woods', 'greyfen'].includes(district)) return 'eerie';
  return 'exploration';
}
